import { render, staticRenderFns } from "./DriverDetailAdminVerification.vue?vue&type=template&id=220daff5&scoped=true&"
import script from "./DriverDetailAdminVerification.vue?vue&type=script&lang=js&"
export * from "./DriverDetailAdminVerification.vue?vue&type=script&lang=js&"
import style0 from "./DriverDetailAdminVerification.vue?vue&type=style&index=0&id=220daff5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220daff5",
  null
  
)

export default component.exports